import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { AdministracaoHome } from './AdministracaoHome';
import { ConfiguracaoEvolutionAPI } from './ConfiguracaoEvolutionAPI';
import { GerenciarEmpresas } from './GerenciarEmpresas';
import { GerenciarUsuarios } from './GerenciarUsuarios';
import { GerenciarInfraestruturaChatbot } from './GerenciarInfraestruturaChatbot';

const Stack = createNativeStackNavigator();

export function AdministracaoStack() {
  return (
    <Stack.Navigator
      initialRouteName="AdministracaoHome"
      screenOptions={{
        headerShown: true,
        headerStyle: {
          backgroundColor: '#f5f5f5',
        },
        headerTintColor: '#000',
        headerTitleStyle: {
          fontWeight: 'bold',
        },
      }}
    >
      <Stack.Screen 
        name="AdministracaoHome" 
        component={AdministracaoHome} 
        options={{ title: 'Administração' }} 
      />
      <Stack.Screen 
        name="ConfiguracaoEvolutionAPI" 
        component={ConfiguracaoEvolutionAPI} 
        options={{ title: 'Configuração Evolution API' }} 
      />

      <Stack.Screen 
        name="GerenciarInfraestruturaChatbot" 
        component={GerenciarInfraestruturaChatbot} 
        options={{ title: 'Infraestrutura do Chatbot' }} 
      />
      <Stack.Screen 
        name="GerenciarEmpresas" 
        component={GerenciarEmpresas} 
        options={{ title: 'Gerenciar Empresas' }} 
      />
      <Stack.Screen 
        name="GerenciarUsuarios" 
        component={GerenciarUsuarios} 
        options={{ title: 'Gerenciar Usuários' }} 
      />
    </Stack.Navigator>
  );
}
